import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useEffect, useState } from 'react';

function ChangePasswordModal(props) {
  const { onChangePassword, confirmBtn, ...rest } = props;
  const [form, setForm] = useState({
    password: '',
    newPassword: '',
    confirmNewPassword: '',
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setForm({ password: '', newPassword: '', confirmNewPassword: '' });
    setErrors({});
  }, [props.show]);

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });

    if (!!errors[field])
      setErrors({
        ...errors,
        [field]: null,
      });
  };

  const findFormErrors = () => {
    const { password, newPassword, confirmNewPassword } = form;
    const newErrors = {};

    // password errors
    if (!password || password === '') {
      newErrors.password = 'Du måste ange ditt nuvarande lösenord.';
    }
    // newPassword errors
    if (!newPassword || newPassword === '') {
      newErrors.newPassword = 'Du måste ange ett nytt lösenord.';
    } else if (/[0-9]/.test(newPassword) === false) {
      newErrors.newPassword = 'Lösenordet måste innehålla minst en siffra.';
    } else if (/[a-z]/.test(newPassword) === false) {
      newErrors.newPassword =
        'Lösenordet måste innehålla minst en liten bokstav.';
    } else if (/[A-Z]/.test(newPassword) === false) {
      newErrors.newPassword =
        'Lösenordet måste innehålla minst en stor bokstav.';
    } else if (
      /[""!@$%^&*(){}\[\]:;<>,.?/+_=|'~\\-]/.test(newPassword) === false
    ) {
      newErrors.newPassword =
        'Lösenordet måste innehålla minst ett specialtecken.';
    } else if (newPassword === password) {
      newErrors.newPassword =
        'Det nya lösenordet kan inte vara samma som det nuvarande lösenordet.';
    }
    // confirmNewPassword errors
    if (!confirmNewPassword || confirmNewPassword === '') {
      newErrors.confirmNewPassword = 'Du måste bekräfta ditt nya lösenord.';
    } else if (confirmNewPassword !== newPassword) {
      newErrors.confirmNewPassword =
        'Det angivna lösenordet matchar inte det nya lösenordet.';
    }

    return newErrors;
  };

  const handleSubmit = () => {
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      onChangePassword(form.password, form.newPassword);
    }
  };

  return (
    <Modal
      {...rest}
      centered
      aria-labelledby='contained-modal-title-vcenter'
      className='p-3'
    >
      <Modal.Header closeButton>
        <Modal.Title>Ändra lösenord</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className='mt-2'>
            <Form.Label>Nuvarande lösenord</Form.Label>
            <Form.Control
              type='password'
              name='password'
              defaultValue={form?.password}
              placeholder='Ange nuvarande lösenord'
              onChange={(e) => setField('password', e.target.value)}
              isInvalid={!!errors.password}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.password}
            </Form.Control.Feedback>
          </Form.Group>
          <p className='mt-4'>
            Välj ett nytt lösenord. Minst 8 tecken samt måste innehålla gemener,
            versaler, siffror och specialtecken.
          </p>
          <Form.Group className='mt-2'>
            <Form.Label>Ange nytt lösenord</Form.Label>
            <Form.Control
              type='password'
              name='newPassword'
              defaultValue={form?.newPassword}
              placeholder='Ange nytt lösenord'
              onChange={(e) => setField('newPassword', e.target.value)}
              isInvalid={!!errors.newPassword}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.newPassword}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className='mt-2'>
            <Form.Label>Upprepa nytt lösenord</Form.Label>
            <Form.Control
              type='password'
              name='confirmNewPassword'
              defaultValue={form?.confirmNewPassword}
              placeholder='Ange nytt lösenord'
              onChange={(e) => setField('confirmNewPassword', e.target.value)}
              isInvalid={!!errors.confirmNewPassword}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.confirmNewPassword}
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className='d-flex justify-content-between'>
        <Button onClick={() => props.onHide()} variant='outline-secondary'>
          Avbryt
        </Button>
        <Button onClick={handleSubmit} className='mt-2'>
          {confirmBtn}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ChangePasswordModal;
